import React from "react"
import Price from "components/Price/Price"
import Availability from "components/Product/Availability"
import LabelSale from "components/Product/LabelSale"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import Typeahead from "components/Typeahead/Typeahead"
import { observer } from "mobx-react"
import * as PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Button, Image, Popup, Table } from "semantic-ui-react"

import quickorderStore from "stores/quickorderStore"

@observer
export default class QuickorderLineItem extends React.Component {


  constructor( props ) {
    super( props )
    this.refCount = React.createRef();
  }

  state = {
    update: false
  }

  handleKeypress = ( event ) => {
    console.log( "KEY", event.key )
  }

  focusCount = () => {
    if ( this.refCount && this.refCount.current) {
      this.refCount.current.focus()
    }
  }

  render() {

    let { lineItem, index, innerRef } = this.props
    const { loading, ready, product, articleNumber } = lineItem
    const hasInvalidId = !product && articleNumber && !loading

    const { warning } = product

    return <Table.Row positive={ready} warning={product && !!product.warning} key={lineItem.map_id + index}>
      <Table.Cell>
        <div className="flex items-center">
          {product && <div className="pl1">
            <Button basic icon={"close"} onClick={() => quickorderStore.remove( index )}/>
          </div>}
        </div>
      </Table.Cell>

      <Table.Cell>
        <div className="flex items-center">
          <div className="">{1 + index}.</div>
        </div>
      </Table.Cell>
      <Table.Cell>
        <Typeahead
          id={this.props.id}
          defaultValue={articleNumber}
          onChange={( { value }, e ) => {
            this.handleKeypress( e )
            quickorderStore.setPosition( index, value )
          }}
          onSelect={value => {
            if (value.product) {
              quickorderStore.setPosition( index, value.product.article_nr )
              setTimeout( () => {
                this.focusCount()
              }, 150 )              
            }
          }}
          resultRenderer={entry => {
            return <div>{entry.title}</div>
          }}
          innerRef={innerRef}
        />
        {/*<Input defaultValue={articleNumber} loading={loading} fluid onChange={e => {*/}
        {/*  quickorderStore.setPosition( index, e.target.value )*/}
        {/*}}/>*/}
      </Table.Cell>

      <Table.Cell>
        {hasInvalidId && <div>
          {translate( "Kein Produkt gefunden" )}
        </div>}
        {product && <div>
          <div className="flex ">
            <div className="img pr1 tc " style={{ width: 45 }}>
              <a  href={`/product/${product.map_id}/`} target={"_blank"}>
                <Image  target={"_blank"} inline src={product.img_src_small} height={40}/>
              </a>
            </div>

            <div className="text f6">
              <div>{product.desc.des}</div>
              <div>{product.article_nr}</div>
            </div>

            <div className=" ml-auto mr0">
              <div className="tr"><Price>{product.price}</Price></div>
              {product.isSale && <LabelSale price={product.originalPrice} percent={product.salePercent}/>}
            </div>
          </div>
        </div>}
      </Table.Cell>

      <Table.Cell>
        <div className="tc">{product && <Availability product={product} type={"tiny"}/>}</div>
      </Table.Cell>

      <Table.Cell textAlign={"right"}>
        <div>
          {product && <div className="pr2 flex justify-between items-center">
            <div className={"pr2"}>{product.unit_multi * product.count} {product.unit_id}</div>
            <ProductQuantityGroup
              showVE={false}
              showHint={true}
              ref={this.refCount}
              className="dib"
              value={product.count}
              onChange={( { product } ) => {
                console.log( { product } )
                quickorderStore.calculate()
                this.setState( { update: true } )
              }}
              onKeyEnter={() => {
                this.props.onFinishPosition && this.props.onFinishPosition()
              }}
              product={product}/>

          </div>
          }
        </div>
      </Table.Cell>

      <Table.Cell>
        <div className="flex justify-center">
          {product.warning && <Popup content={product.warning} trigger={<Button color={"yellow"} icon={"warning circle"} title={product.warning}/>}/>}
          {(product && !product.warning) && <Button basic color={"green"} icon={"check circle"}/>}
        </div>
      </Table.Cell>
    </Table.Row>
  }
}


QuickorderLineItem.propTypes = {
  lineItem: PropTypes.any,
  index   : PropTypes.any
}



// WEBPACK FOOTER //
// ./src/components/Quickorder/QuickorderLineItem.js